import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import LegacySurveyQuestionForm from '../form/LegacySurveyQuestionForm';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';

const LegacySurveyQuestionModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();
  const params = useParams();

  const { mutate: createLegacySurveyQuestion } =
    fitSurvey2Services.useMutationCreateLegacySurveyQuestion(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-question'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacySurveyQuestion } =
    fitSurvey2Services.useMutationUpdateLegacySurveyQuestion(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-question'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    let answers = [];
    if (data.isNoAnswer) {
      const checked = data.answers.findIndex((item) => {
        return item.answer === 'ไม่มีคำตอบ';
      });

      if (checked === -1) {
        answers = [{ imageUrl: '', answer: 'ไม่มีคำตอบ', isOther: false }];
      }
    }
    answers = [...answers, ...data.answers];
    if (data.isHasOther) {
      const checked = data.answers.findIndex((item) => {
        return item.answer === 'อื่นๆ โปรดระบุ';
      });

      if (checked === -1) {
        answers.push({ imageUrl: '', answer: 'อื่นๆ โปรดระบุ', isOther: true });
      }
    }
    const legaySurveyQuestionData = {
      imageUrl: data.imageUrl,
      question: data.question,
      answers,
      display: true,
      type: data.type,
      partId: params.partId,
      required: data.required,
      condition: data.condition,
      conditionNumber: data.conditionNumber,
      isHasOther: data.isHasOther,
      isUserAnswerText: data.isUserAnswerText,
      isNoAnswer: data.isNoAnswer,
      answerType: data.answerType,
    };

    if (watch('formType') === 'create') {
      createLegacySurveyQuestion(legaySurveyQuestionData);
    } else if (watch('formType') === 'edit') {
      editLegacySurveyQuestion({ id: data.id, data: legaySurveyQuestionData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มหมวดแบบสอบถาม'
          : 'แก้ไขหมวดแบบสอบถาม'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacySurveyQuestionForm />
    </Modal>
  );
};

export default LegacySurveyQuestionModal;
